import React from 'react';
import {
  themeColor,
  itvThemeColor,
  tabletMediaQuery,
  mobileMediaQuery,
} from '../../Theming';
import styled from 'styled-components';
import ItvLogo from '../Logos/ItvLogo';
import DominosLogo from '../Logos/DominosLogo';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 64px;
  background-color: ${itvThemeColor('greenishBlue')};
  justify-content: space-between;
  padding-inline: 20px;

  ${tabletMediaQuery} {
    height: 48px;
  }
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const RightSection = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${themeColor('white')};
  font-family: Arial;
  font-size: 16px;
  text-decoration: underline;
  cursor: pointer;

  ${tabletMediaQuery} {
    font-size: 12px;
  }
`;

const SponseredText = styled.span`
  font-size: 21px;
  font-family: Arial;
  color: #aac0c8;
  padding-left: 12px;
  padding-right: 4px;

  ${tabletMediaQuery} {
    font-size: 10px;
  }
`;

const LogoContainer = styled.div`
  height: 34px;
  width: 34px;
  margin-left: 5px;

  ${mobileMediaQuery} {
    height: 16px;
    width: 16px;
    margin-left: 2px;
  }
`;

const StandardHeader: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Container id="itv-header-container">
      <LeftSection id="itv-header-leftSection">
        <ItvLogo />
        <SponseredText id="itv-header-sponsoredText">
          {t('extension.itvActivation.header.sponsoredBy')}
        </SponseredText>
        <LogoContainer>
          <DominosLogo />
        </LogoContainer>
      </LeftSection>
      <RightSection id="itv-header-rightSection">
        {t('extension.itvActivation.header.backToMainSite')}
      </RightSection>
    </Container>
  );
};

export default StandardHeader;
